import type { ComponentProps } from "react";
import { cn } from "@volca/ui/lib/utils";
import { GLYPHS, type GlyphName } from "@volca/ui/trades";

/** 1em and `currentColor`, so it sits beside a Phosphor icon. */
export const TradeGlyph = ({
  name,
  className,
  ...props
}: ComponentProps<"svg"> & { name: GlyphName }) => (
  <svg
    viewBox="0 0 256 256"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={16}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    data-slot="trade-glyph"
    data-glyph={name}
    className={cn("shrink-0", className)}
    {...props}
  >
    {GLYPHS[name].map((d) => (
      <path key={d} d={d} />
    ))}
  </svg>
);
